import bbox from "@turf/bbox";
import * as turf from "@turf/helpers";
import center from "@turf/center";
import {
  ProcessedImage,
  ProcessedPointCloud,
  ProcessedGeometry,
} from "components/Orders/state/types";

export const getCenter = (
  images: ProcessedImage[],
  pointclouds: ProcessedPointCloud[]
) => {
  if (
    images.length === 0 ||
    images.some((image) => image.data?.exif?.geoLocation === undefined)
  ) {
    if (pointclouds.length > 0) {
      if (
        pointclouds.some((pointcloud) => pointcloud.data?.bbox === undefined)
      ) {
        return null;
      }

      const feature = center(
        turf.featureCollection(
          pointclouds.map((pointcloud) => turf.point(pointcloud.data.bbox))
        )
      );

      return feature.geometry.coordinates;
    }

    return null;
  }

  const feature = center(
    turf.featureCollection(
      images.map((image) =>
        turf.point([
          image.data.exif.geoLocation.longitude,
          image.data.exif.geoLocation.latitude,
        ])
      )
    )
  );

  return feature.geometry.coordinates;
};

export const centerMapToAssets = (
  map: mapboxgl.Map,
  images: ProcessedImage[],
  animate = false
) => {
  try {
    const all = bbox(
      turf.featureCollection(
        images.map((image) =>
          turf.point([
            image.data.exif.geoLocation.longitude,
            image.data.exif.geoLocation.latitude,
          ])
        )
      )
    );

    map.fitBounds(
      [
        [all[0], all[1]],
        [all[2], all[3]],
      ],
      {
        animate: animate || false,
        duration: animate ? 1500 : 0,
        padding: 64,
        maxZoom: 16,
      }
    );
  } catch (error) {
    console.warn("Failed to center map on assets:", error);
  }
};

export const getGeometryDisplayName = (geometry: ProcessedGeometry): string => {
  return geometry.label || geometry.name;
};
